import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    // Aggiunge automaticamente withCredentials in modo da inviare sempre il token di refresh HTTPOnly al server
    request = request.clone({
      withCredentials: true, // Per poter salvare gli HttpCookies
      // Per indicare al backend da dove proviene la richiesta (x-test-origin decide la durata del token in login/refresh)
      setHeaders: { 'x-nestor-origin': 'web', 'x-test-origin': 'web' }
   });

  return next.handle(request);
  }
}
